import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NewsPromotionCard } from './NewsPromotionCard';
import { brizUaAPI, NewsShareItem } from '../../../services/apiServices/brizUa';
import { useAppSelector } from '../../../hooks/redux';
import { NewsPromotionCardSkeleton } from './NewsPromotionCardSkeleton';
import { useDateLocalization } from '../../../hooks/useDateLocalization';

export const NewsPromotions: FC = () => {
  const { t } = useTranslation();
  const { formatDate } = useDateLocalization();
  const [appNews, setAppNews] = useState<NewsShareItem[] | []>([]);
  const { selectedLanguage } = useAppSelector((state) => state.langReducer);
  const {
    data: news,
    refetch: reFetchNews,
    isLoading: isLoadingNews,
  } = brizUaAPI.useGetNewsQuery({ limit: '3', lang: selectedLanguage });

  useEffect(() => {
    if (news) {
      setAppNews(news.items);
    }
  }, [news]);

  useEffect(() => {
    reFetchNews();
  }, [selectedLanguage]);

  const convertTimestampToDate = (value: number | null) => {
    if (value) {
      const date = new Date(value * 1000);
      return formatDate(date, { day: '2-digit', month: '2-digit', year: 'numeric', locale: 'uk' });
    }
    return '';
  };

  return (
    <div className="news-promotions-container">
      <div className="news-promotions-container__header">
        <strong className="home-title">{t('home.news')}</strong>
      </div>
      <div className="news-promotions-container__cards">
        {isLoadingNews && (
          <>
            <NewsPromotionCardSkeleton />
            <NewsPromotionCardSkeleton />
          </>
        )}
        {isLoadingNews && <NewsPromotionCardSkeleton />}
        {appNews &&
          appNews.map((el) => {
            return (
              <NewsPromotionCard
                img={el.thumbnail || ''}
                title={el.title || ''}
                key={el.url}
                date={convertTimestampToDate(el.published)}
                link={el.url || ''}
              />
            );
          })}
      </div>
    </div>
  );
};
